import React, { useEffect, useRef, useState } from "react";
import {
  duplicate_plus,
  green_check,
  purple_excla,
  red_cross,
} from "../../../images";
import { TableWork } from "../../../ui";
import Button from "../../../library/components/Button";
import { TableLabel } from "./TableLabel";
import { createAlert } from "../../../features/alert/alerts";
import {
  ALERT_TYPE_SUCCESS,
  ALERT_TYPE_ERROR,
  ALERT_TYPE_INFO,
} from "../../../constants/constants";
import {
  useAddElectorMannualy13CMutation,
  useGetElectorQuery,
  useGetForm13CQuery,
  useScanner13CMutation,
} from "../../../services/preCountingServices";
import BarcodeReader from "react-barcode-reader";
import "./index.css";
import { useDispatch } from "react-redux";
import ConfirmationModal from "../../../library/components/FileUpload/ConfirmationModal/ConfirmationModal";
import CustomModal from "../../../library/components/Modal/modal";
import { Modal } from "react-bootstrap";
import MessageModal from "../../../library/components/FileUpload/ConfirmationModal/MessageModal";
import PrecountingModal from "../PrecountingModal/PrecountingModal";
import { useGetScannedUpdateQuery } from "../../../services/reportsServices";
// import BarcodeScannerComponent from "react-qr-barcode-scanner";
import alertIcon from "../../../dashboardicon/alert.svg"
import { isValidFileNameFormC } from "../../utilities/utils";

export const FormC = ({
  isShowCameraPopup,
  onCameraPopopUpdate,
  onCameraPopopError,
  setonCameraPopopUpdate,
}) => {
  const [electorDetail, setElectorDetail] = useState();
  const dispatch = useDispatch();
  const [skip, setskip] = useState(true);
  const [searchElector, setsearchElector] = useState("");
  const[getUpdate,setUpdate]=useState(true)
  const [scanData, setScanData] = useState("");
  const { data: form13c, refetch } = useGetForm13CQuery();
  const { data: electorData ,isSuccess} = useGetElectorQuery(searchElector, {
    skip: searchElector.length >= 3 ? false : skip,
  });
  const [addElectorManually, datac] = useAddElectorMannualy13CMutation();
  const {data:updateScannedStatus,isSuccess:updateScannedStatusSuccess,isError:updateScannedStatusError} = useGetScannedUpdateQuery("",{skip:getUpdate})
  const [scanForm13C, datap] = useScanner13CMutation();
  const [isDuplicateAllowed, setisDuplicateAllowed] = useState("");
  const [remove, setRemove] = useState(false);
  const [error, setError] = useState(false);
  const [showConfirmationPopup, setConfirmationPopup] = useState(false);
  const [showConfirmationPopupManual, setConfirmationPopupManual] =
    useState(false);
  const [test, setTest] = useState("");
  const [tableBody, setTableBody] = useState([]);
  const electorList = [];
  const [alertMessage, setAlertMessage] = useState(false);
  const [JunkalertMessage, setJunkAlertMessage] = useState(false);
  const [storedScanData,setStoredScanData] = useState("")
    const debounceTimeout = useRef(null);
    
  useEffect(() => {
    refetch();
  }, []);

  useEffect(() => {
    let tData = [];
    form13c?.payload?.responseStatusForm13cDtoList?.map((item, i) => {
      tData.push({
        "S.No": item.slNo13C,
        Elector_Name: item.fullName,
        Status:
          item.form13cScanStatus === "V" ? (
            <TableLabel icon={green_check} color={"#24bc2a"} label={"Valid"} />
          ) : item.form13cScanStatus === "I" ? (
            <TableLabel icon={red_cross} color={"#E30000"} label={"Invalid"} />
          ) : item.form13cScanStatus === "D" ? (
            <TableLabel
              icon={duplicate_plus}
              color={"#E66E00"}
              label={item.message}
            />
          ) : (
            item.form13cScanStatus === "N" && (
              <TableLabel
                icon={purple_excla}
                color={"#8D00BE"}
                label={item.message}
              />
            )
          ),
      });
      window.scrollTo(0, 0);
    });
    setTableBody(tData);

    if(localStorage?.userrole=="cs" && form13c?.payload?.responseStatusForm13cDtoList?.length==1){
setUpdate(false)
    }
  }, [form13c]);

  // useEffect(()=>{  
  //     console.log(electorData?.payload?.filter((item)=>{
  //       console.log("hiiii");
  //       return (item.fullName).includes(searchElector)
  //       }))
  // },[searchElector])

  useEffect(()=>{
    if(localStorage?.userrole=="cs"){
      setUpdate(true)
    }
  },[updateScannedStatusSuccess,updateScannedStatusError])

  electorData?.payload.map((item, i) => {
    electorList.push({
      ElectorId: item.electorId,
      label: `${item.fullName} / ${item.address}`,
    });
  });
  const data = {
    head: ["S. No.", "Elector Name", "Scanned"],
  };
  const myFunction = () => {
    document.getElementById("myDropdown").classList.toggle("show");
    document.getElementById('myInputA').focus();
   
  };
  const filterFunction = () => {
    let input, filter, a, i;
    input = document.getElementById("myInputA");
    filter = input.value.toUpperCase();
    let div = document.getElementById("myDropdown");
    a = div.getElementsByTagName("a");
    for (i = 0; i < a.length; i++) {
      var txtValue = a[i].textContent || a[i].innerText;

      if (txtValue.toUpperCase().indexOf(filter) > -1) {
        a[i].style.display = "";
      } else {
        a[i].style.display = "none";
      }
    }
  };
  const onSuccess = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_SUCCESS,
        heading: "Success",
      })
    );
  };
  const onReject = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_ERROR,
        heading: "Reject",
      })
    );
  };
  const onInfo = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_INFO,
        heading: "INFO",
      })
    );
  };
  const addElector = () => {
    if (electorDetail) {
      addElectorManually(electorDetail)
        .unwrap()
        .then((res) => {
          if (
            res.statusCode == 404 &&
            res?.message?.includes("Please make a complete scan")
          ) {
            onInfo(res?.message);
          }
          if (res?.message?.includes("previously scanned")) {
            setConfirmationPopupManual(true);
          } else {
            if (res.statusCode == 200) {
              onSuccess(res?.message);
            }

            refetch();
            setElectorDetail("");
          }
        })
        .catch((res) => {
          console.log(res)
          refetch();
          setElectorDetail("");
        });
    } else {
      onInfo("Please Select Elector From Dropdown");
    }
  };

  useEffect(() => {
    if (datac.isError) {
      // onReject(datac?.error?.data?.message);
    }
    if (datac.isSuccess) {
      // onSuccess(datac?.data?.message);
    }
  }, [datac.isError, datac.isSuccess]);

  

  // useEffect(()=>{
  //   handleScan("#######79")
  // },[])


  const handleScan = (data) => {
    
    if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
        debounceTimeout.current = setTimeout(() => {
          setJunkAlertMessage(false);
          setAlertMessage(true);
            setScanData(""); // Clear the scan data
        }, 200); // Debounce time in milliseconds
    } else {
        debounceTimeout.current = setTimeout(() => {
            debounceTimeout.current = null; // Reset debounce timeout
            if(!isValidFileNameFormC(data)){
              setStoredScanData(data);
              setJunkAlertMessage(true);
              return
            }else{
              setScanData(data);
            }
            setAlertMessage(false); // Clear any previous alert
            // runApi(data); // Call the API directly here
        }, 450); // Debounce time in milliseconds
    }
};

  //////////////////////// Web Cam Code
  // useEffect(() => {
  //   if (isShowCameraPopup && onCameraPopopUpdate) {
  //     handleScan(onCameraPopopUpdate);
  //     setonCameraPopopUpdate("")
  //   }
  // }, [onCameraPopopUpdate,onCameraPopopError,isShowCameraPopup]);

  ///////////////////////////////////////

  const handleError = (err) => {};

  useEffect(() => {
    if (scanData !== "") {
      setJunkAlertMessage(false);
      setStoredScanData("")
      debounceTimeout.current = null;
      scanForm13C({
        epbFileName: scanData,
        isFirstTimeScan: "",
      })
        .unwrap()
        .then((res) => {
          if (res?.message?.includes("previously scanned")) {
            setConfirmationPopup(true);
          } else {
            if (res.statusCode == 200) {
              onSuccess(res?.message);
            }
            refetch();
            setScanData("");
          }
        })
        .catch(() => {
          refetch();
          setScanData("");
        });
    }
  }, [scanData]);

  useEffect(() => {}, [datap.isError, datap.isSuccess]);

  const onClose = () => {
    setConfirmationPopup(false);
    setScanData("");
  };

  const reset = () => {
    scanForm13C({
      epbFileName: scanData,
      isFirstTimeScan: "No",
    })
      .unwrap()
      .then((res) => {
        if (String(res.message).includes("complete scan")) {
          onInfo(res.message);
        }
        refetch();
        setScanData("");
      });
    setRemove(false);
    setConfirmationPopup(false);
    setScanData("");
  };

  const resetManual = () => {
    addElectorManually({
      id: electorDetail.id,
      fullName: electorDetail.fullName,
      epbId: electorDetail.epbId,
      address: electorDetail.address,
      isFirstTimeScan: "No",
    })
      .unwrap()
      .then((res) => {
        if (String(res.message).includes("complete scan")) {
          onInfo(res.message);
        }
        refetch();
        setElectorDetail("");
      });
    setRemove(false);
    setConfirmationPopupManual(false);
    setElectorDetail("");
  };

  return (
    <>
    {
        <CustomModal
          className="confirmation_modal"
          show={alertMessage}
          onClose={()=>{setAlertMessage(false);
          setScanData("");
          debounceTimeout.current = null
          }}
          closeIcon={false}
          size="700px"
          modalTitle={<>
            <div style={{display:"flex"}}><img src={alertIcon} style={{marginRight:"10px",height:"30px",width:"30px"}} /><h3 style={{color:"red"}}>Alert : Please read carefully !</h3></div>
        <hr/>
          </>
          }
          children={  
            <>
            <p style={{fontSize:"17px"}}>Your QR Code Scanner has returned multiple values, it should return only one value at a time. You may try to scan again, or reset your QR Code scanner or replace the Computer. In case the QR Code returns multiple values, keep on scanning again or try on another computer with your own login id. If it still persist, you may add manually.</p>
            <button type="button" className="btn btn-primary" onClick={()=>{
            setAlertMessage(false);
            setScanData("");
            debounceTimeout.current = null
            }} style={{
              float:"right",
              margin:"15px"
            }}>OK</button>
            </>
          }         
        />
      }
      {
        <CustomModal
          className="confirmation_modal"
          show={JunkalertMessage}
          // onClose={()=>{setJunkAlertMessage(false)}}
          closeIcon={false}
          size="700px"
          modalTitle={<>
          <div style={{display:"flex"}}><img src={alertIcon} style={{marginRight:"10px",height:"30px",width:"30px"}} /><h3 style={{color:"red"}}>Alert : Please read carefully !</h3></div>
          <hr/>
          </>
          }
          children={  
            <>
            <p style={{fontSize:"17px" ,marginBottom:"40px"}}>Your QR Code Scanner has returned invalid value, or you must have scanned wrong QR Code. You may try to scan again, or reset your QR Code scanner or replace the Computer or add manually.<br/> If you want to scan again or add manually click on <span style={{backgroundColor:"#007bff", padding:"2px", borderRadius:"2px",color:"white",fontWeight:600}}>"Scan Again/Add Manually"</span> else click on <span style={{backgroundColor:"#ffc107", padding:"2px", borderRadius:"2px",color:"black",fontWeight:600}}>"Proceed With The Scanned Value"</span> to proceed with the value that you have scanned.<br/><span style={{ color:"red"}}> Note that if you proceed with the scanned value, the system will mark it as invalid.</span></p>
            <button type="button" className="btn btn-warning" onClick={()=>{
           setScanData(storedScanData);
            }} style={{
              float:"left",
              margin:"15px"
            }}>Proceed With The Scanned Value</button>
            <button type="button" className="btn btn-primary" onClick={()=>{
           setJunkAlertMessage(false);
           setStoredScanData("");
            }} style={{
              float:"right",
              margin:"15px"
            }}>Scan Again/Add Manually</button>
            </>
          }         
        />
      }
      {
        <CustomModal
          className="confirmation_modal"
          show={showConfirmationPopup}
          onClose={onClose}
          closeIcon={false}
          modalTitle={""}
          children={
            <PrecountingModal
              noOption={reset}
              size="500px"
              yesOption={() => {
                setScanData("");
                setConfirmationPopup(false);
              }}
            />
          }
        />
      }
      {
        <CustomModal
          className="confirmation_modal"
          show={showConfirmationPopupManual}
          onClose={onClose}
          // size="500px"
          closeIcon={false}
          modalTitle={""}
          children={
            <PrecountingModal
              noOption={resetManual}
              size="500px"
              yesOption={() => {
                addElectorManually({
                  id: electorDetail.id,
                  fullName: electorDetail.fullName,
                  epbId: electorDetail.epbId,
                  address: electorDetail.address,
                  isFirstTimeScan: "Yes",
                })
                  .unwrap()
                  .then((res) => {
                    if (String(res.message).includes("previously scanned")) {
                      onInfo(res.message);
                    }
                    setConfirmationPopupManual(false);
                  });
              }}
            />
          }
        />
      }

      <BarcodeReader onError={handleError} onScan={handleScan} />
      {/* <BarcodeScannerComponent onError={""} onUpdate={""}/> */}
      <div className="form-c">
        <div className="head-title mb-3">
          <span className="headingpreCounting">
            <strong className="mr-1">Add Elector Manually </strong>
            (in case QR Code is not scanned)
          </span>
          <div className="add-elector">
            <div className="SearchElectorDropdown">
              <div class="dropdownn col-md-12">
                <button
                  onClick={() => myFunction()}
                  class="dropbtn col-md-12 mx-2"
                >
                  {electorDetail
                    ? `${electorDetail.fullName} / ${electorDetail.address}`
                    : ""}
                </button>
                <div id="myDropdown" class="dropdownn-content-A">
                  <input
                    type="text"
                    placeholder="Type here atleast 3 char.. (i.e dem)"
                    id="myInputA"
                    onKeyUp={() => {
                      filterFunction();
                    }}
                    onChange={(e) => {
                      setsearchElector(e.target.value);
                      // setskip(false);
                    }}
                  />
                  {electorData?.payload?.map((item) => (
                    <a
                      href="#about"
                      id={JSON.stringify({
                        id: item.id,
                        fullName: item.fullName,
                        epbId: item.epbId,
                        address: item.address,
                        isFirstTimeScan: "Y",
                      })}
                      onClick={(e) => {
                        var contentId = JSON.parse(e.target.getAttribute("id"));
                        setElectorDetail(contentId);
                        myFunction();
                      }}
                    >
                      {`${item.fullName} / ${item.address}`}
                    </a>
                  ))}
                </div>
              </div>
            </div>
            <Button
              className
              fa_icon="fa-plus plus-icon"
              onClick={addElector}
              value="Add"
            />
          </div>
        </div>
        <TableWork
          id=""
          theadData={data.head}
          tbodyData={tableBody}
          anchorTagName=""
          anchorTagclassName="viewDetails"
          emptyMessage="No data found"
          pageSize={10}
          pagination={true}
          paginationClass={"text-right p-0"}
        />
      </div>
    </>
  );
};
